module.exports = __webpack_public_path__ + "img/RIO_Logo_Shield_Yellow on Blue.10aa58fe.png";